<template>
    <div class="tree-box">
        <div class="drag-tip" v-if="draggable">
            <i class="el-icon-rank"></i> 按住行拖动可调整列顺序
        </div>
        <el-scrollbar class="tree">
            <el-tree
            class="custom_columns_tree"
            ref="customColumnsTree"
            v-loading="loading"
            :data="customColumns"
            show-checkbox
            node-key="id"
            check-on-click-node
            :expand-on-click-node="false"
            default-expand-all
            @node-click="nodeClick"
            check-strictly
            :draggable="draggable"
            :allow-drop="allowDrop"
            @node-drop="nodeDrop"
            :props="defaultProps"
            >
            </el-tree>
            
        </el-scrollbar>
        <div class="op-row">
            <el-button size="small" @click="cancel">取消</el-button>
            <el-button type="primary" size="small" @click="confirm">确认</el-button>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    // 是否开启拖动排序（默认关闭，保证其它复用方的原有行为与样式完全不变）
    draggable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      customColumns: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
    };
  },
  methods: {
    // 设置自定义列详情
    setCustomcolumns(tempArr) {
      this.customColumns = tempArr;
      this.setDefaultCheckedKeys();
    },
    setDefaultCheckedKeys() {
      let arr = [];
      this.customColumns.forEach((item) => {
        if (item.isShow == "Y") {
          arr.push(item.id);
        }
        if (item.children && item.children.length) {
          item.children.forEach((row) => {
            if (row.isShow == "Y") {
              arr.push(row.id);
            }
          });
        }
      });
      this.$nextTick(() => {
        this.$refs["customColumnsTree"].setCheckedKeys(arr);
      });
    },
    nodeClick(data, node) {
      this.$set(data, "isShow", node.checked ? "Y" : "N");
      if (node.childNodes.length) {
        node.childNodes.forEach((item) => {
          this.$set(item, "checked", node.checked);
          this.$set(item.data, "isShow", node.checked ? "Y" : "N");
        });
      }
      if (node.level != 1) {
        let checked = node.parent.childNodes.every(
          (item) => item.checked == false
        );
        this.$set(node.parent, "checked", !checked);
        this.$set(node.parent.data, "isShow", checked ? "N" : "Y");
      }
    },
    // 只允许同级拖动，避免拖拽把列拖到其它层级导致结构错乱
    allowDrop(draggingNode, dropNode, type) {
      return type === "prev" || type === "next";
    },
    // 拖动结束：按树中新的同级顺序重写 sort（与系统原有实现同口径：sort 与数组下标一致）
    nodeDrop(draggingNode, dropNode) {
      const level = (draggingNode && draggingNode.level) || 1;
      if (level === 1) {
        this.customColumns.forEach((item, index) => {
          this.$set(item, "sort", index);
        });
      } else {
        const parent = dropNode && dropNode.parent ? dropNode.parent.data : null;
        if (parent && parent.children && parent.children.length) {
          parent.children.forEach((item, index) => {
            this.$set(item, "sort", index);
          });
        }
      }
    },
    cancel(){
        this.$emit('confirm', false)
    },
    confirm(){
        this.$emit('confirm', true)
    }
  },
};
</script>

<style scoped lang="less">
.tree {
  min-height: 400px;
  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  ::v-deep .custom_columns_tree {
    max-height: 400px;
    
    .el-tree-node__label {
      position: relative;
      &:before {
        content: "";
        width: 20px;
        height: 20px;
        display: block;
        position: absolute;
        top: 0px;
        left: -24px;
        z-index: 999;
      }
      .el-checkbox__inner {
        top: 0;
      }
    }
  }
}
.tree-box{
    margin-top: -20px;
}
.op-row{
    text-align: right;
    margin-bottom: -20px;
    margin-top: 8px;
}
// 自定义列拖动排序提示（仅 draggable 时渲染）
.drag-tip {
    font-size: 12px;
    color: #909399;
    padding-bottom: 6px;
    margin-bottom: 6px;
    border-bottom: 1px dashed #ebeef5;
    i {
        color: #409eff;
    }
}
</style>
